import { render, staticRenderFns } from "./applyListDetail.vue?vue&type=template&id=2245aaf1&scoped=true&"
import script from "./applyListDetail.vue?vue&type=script&lang=js&"
export * from "./applyListDetail.vue?vue&type=script&lang=js&"
import style0 from "./applyListDetail.vue?vue&type=style&index=0&id=2245aaf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245aaf1",
  null
  
)

export default component.exports